import * as React from "react"
import { t } from "ttag"
import { CenteredLoader } from "@humanpredictiveintelligence/myqvt-library"

import { SurveyCard } from "../SurveyCard"
import * as Styles from "./SurveyList.styles"

import { GetCustomSurveysQuery } from "graphql/queries/generated/GetCustomSurveys"

export const SurveyList: React.FC<CustomSurveyListProps> = props => {
  const isListEmpty = !props.surveys?.length

  return (
    <Styles.Container
      $isListEmpty={isListEmpty}
      $isCollapsed={props.isCollapsed}
    >
      {props.isLoading && <CenteredLoader delay={500} isTransparent/>}
      {!props.isLoading &&
        <>
          {isListEmpty && (
            <Styles.EmptyList>{t`No survey to display`}</Styles.EmptyList>
          )}
          {!isListEmpty && (
            <Styles.List>
              {props.surveys?.map((survey, surveyIndex) => (
                <Styles.ListItem key={surveyIndex}>
                  <SurveyCard
                    isInteractive
                    isActive={survey.id === props.activeSurveyId}
                    survey={survey}
                    theme={survey.theme}
                    isMini={props.isCollapsed}
                    shouldNavigate
                  />
                </Styles.ListItem>
              ))}
            </Styles.List>
          )}
        </>}
    </Styles.Container>
  )
}

export interface CustomSurveyListProps {
  /** Render the collapsed version */
  isCollapsed: boolean,

  /** Loading status */
  isLoading: boolean,

  /** Surveys to display in the list */
  surveys: GetCustomSurveysQuery["getCustomSurveys"],

  /** Id of the selected Survey in the list */
  activeSurveyId?: number,
}
